<template>
  <div class="custom-spu-designer-content-mini">
    <div class="operation">
      <div class="customable-group">
        <div v-for="(item, index) in editingImages"
             :key="item.image.id"
             class="customable-switch"
             :class="[currentNode === index ? 'current-node' : '']"
             @click="onSelect(item, index)">
          {{ item.image.name[0] }}
        </div>
      </div>
      <div class="complete"
           @click="isOk"><span>完成设计</span></div>
    </div>
    <span class="color-selected-title">已选颜色</span>
    <div class="color-list">
      <div class="color-list-area">
        <div v-for="color in currentSelectedColors"
             class="color-seleted">
          <div class="color-outer-layer">
            <a-avatar :key="color.value"
                      shape="square"
                      class="color-item"
                      :alt='color.name'
                      :style="[`backgroundColor:${color.value}`, `backgroundImage:url(${color.image})`]"
                      @click="selectCurrentColor(color)">
            </a-avatar>
          </div>
          <img v-show="currentColor?.value === color.value"
               src="../icon/color-selected.png"
               class="color-seleted-icon">
        </div>
      </div>
    </div>
    <div ref="editorContainer"
         class="image-customize-editor"
         :style="textInputFocus ? '' : ''">
      <a-spin :spinning="customImgLoading || savingLoading || segmentedLoading"
              :tip="customImgLoading ? '正在涂鸦...' : savingLoading ? '装裱你的作品...' : '正在裁剪...'"
              size="default">
        <ImageCustomizeEditor v-for="item in editingImages"
                              :id="item.image.id + ''"
                              :ref="(el: any) => (item.fabric = el)"
                              :key="item.image.id"
                              :class="currentEditingImage?.image.id !== item.image.id ? 'hidden' : ''"
                              :is-mini="true"
                              :container="editorContainerDom"
                              :template-basic-parameters="templateBasicParameters(toUrl(findCustomableImage(currentColor as Color, item.image))!, currentColor?.value!, item.image.width, item.image.height, 55)"
                              :custom-area="assignCustomizedData(item)"
                              :default-font="'PingFangSC-Regular, sans-serif'"
                              :customized-area-scale="findCurrentCustomizedScale(item.image.id)!.customized_areas_scale || 1"
                              mode="edit"
                              @img-loading="imgLoading"
                              @custom-active-object="activeObject"
                              @ready="item.onReady"
                              @customized="onCustomized"
                              @drag-drop="dragDrop" />
      </a-spin>
    </div>
    <div class="color-name">{{ currentColor?.name || '' }}</div>
    <div v-show="!materialVisible"
         class="color-list">
      <div class="color-list-area">
        <div v-for="color in currentAvailableColors"
             class="color-outer-layer">
          <a-avatar :key="color.value"
                    shape="square"
                    :class="['color-item', colorShow(color) ? 'selected-color' : '']"
                    :alt='color.name'
                    :style="[`backgroundImage:url(${color.image})`, `backgroundColor:${color.value}`]"
                    @click="onSelectColor(color)">
          </a-avatar>
        </div>
      </div>
    </div>
    <!-- 功能按钮 -->
    <div class="navigation-extend"
         :style="textInputFocus ? '' : ''">
      <!-- 尺寸 -->
      <div v-show="marks && currentNavigationNode === 1"
           class="navigation-scale">
        <div class="navigation-scale-title">
          {{ findCurrentCustomizedScale(currentEditingImage?.image.id as number)?.title }}
        </div>
        <div class="navigation-scale-slider">
          <a-slider v-model:value="currentCustomizedAreaScaleIndex"
                    :max="currentEditingImage?.image.scales.length! - 1"
                    :tip-formatter="null"
                    :step="null"
                    :marks="marks"
                    @change="changeCustomizedScale" />
        </div>
      </div>
      <!-- 文字功能的扩展框 -->
      <div v-show="canvasActiveObject && canvasActiveObject['type'] === 'i-text' && !marks && currentNavigationNode === 2"
           class="navigation-title-extended">
        <!-- 文字 -->
        <a-input v-show="customAreaITextcustomAreaAdjustment === 'text'"
                 v-model:value="customAreaIText"
                 style="color: white;"
                 :bordered="false"
                 @blur="blurText"
                 @focus="focusText" />
        <!-- 描边 -->
        <div v-show="customAreaITextcustomAreaAdjustment === 'stroke'"
             class="navigation-title-extended-edit">
          <div class="navigation-title-extended-edit-slider">
            <div class="edit-slider">
              <a-slider v-model:value="customAreaAdjustment.strokeWidth"
                        :min="0"
                        :max="20" />
            </div>
            <a-input-number v-model:value="customAreaAdjustment.strokeWidth"
                            :min="0"
                            :max="20"
                            class="navigation-title-extended-edit-input" />
          </div>
          <div class="navigation-title-extended-edit-color">
            <input v-model="customAreaAdjustment.strokeColor"
                   type="color" />
          </div>
        </div>
        <!-- 样式 -->
        <div v-show="customAreaITextcustomAreaAdjustment === 'font'"
             class="navigation-title-extended-edit">
          <div class="navigation-title-extended-edit-slider">
            <a-slider v-model:value="customAreaAdjustment.fontSize"
                      class="edit-slider"
                      :min="0"
                      :max="200" />
            <a-input-number v-model:value="customAreaAdjustment.fontSize"
                            :min="0"
                            :max="200"
                            class="navigation-title-extended-edit-input" />
          </div>
          <a-select ref="select"
                    v-model:value="baseFontFamily"
                    class="navigation-title-extended-edit-select"
                    dropdown-class-name="fb-css-ignore-custom-mini"
                    placement="topLeft"
                    :options="systemIsIos ? iosFontFamilyData : androidFontFamilyData"
                    @change="changeFontFamily" />
          <div class="navigation-title-extended-edit-color">
            <input v-model="customAreaAdjustment.fontColor"
                   type="color" />
          </div>
        </div>
      </div>
      <!-- 文字 -->
      <div v-if="canvasActiveObject && canvasActiveObject['type'] === 'i-text' && !marks && currentNavigationNode === 2"
           class="navigation-function">
        <ul class="navigation-function-list">
          <li class="navigation-function-button"
              @click="customAreaITextcustomAreaAdjustment = 'text'">
            <edit-outlined class="icon-size" />
            <p>编辑内容</p>
          </li>
          <li class="navigation-function-button"
              @click="customAreaITextcustomAreaAdjustment = 'stroke'">
            <border-outer-outlined class="icon-size" />
            <p>文字描边</p>
          </li>
          <li class="navigation-function-button"
              @click="customAreaITextcustomAreaAdjustment = 'font'">
            <font-colors-outlined class="icon-size" />
            <p>文字样式</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('flipHorizontal')">
            <img style="width: 13px;height: 20px;"
                 src="/images/flipHorizontal.png" />
            <p>水平翻转</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('flipVertical')">
            <div style="height:20px;">
              <img style="width: 20px;height: 13px;"
                   src="/images/flipVertical.png" />
            </div>
            <p>垂直翻转</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingrRotate(true)">
            <rotate-left-outlined class="icon-size" />
            <p>逆时针45°</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingrRotate(false)">
            <rotate-right-outlined class="icon-size" />
            <p>顺时针45°</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('fontBold')">
            <bold-outlined class="icon-size" />
            <p>加粗</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('fontItalic')">
            <italic-outlined class="icon-size" />
            <p>斜体</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('underline')">
            <underline-outlined class="icon-size" />
            <p>下划线</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('linethrough')">
            <strikethrough-outlined class="icon-size" />
            <p>中划线</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingIText('left')">
            <align-center-outlined class="icon-size" />
            <p>左对齐</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingIText('center')">
            <align-left-outlined class="icon-size" />
            <p>中对其</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingIText('right')">
            <align-right-outlined class="icon-size" />
            <p>右对齐</p>
          </li>
        </ul>
      </div>
      <!-- 图片 -->
      <div v-show="canvasActiveObject && canvasActiveObject['type'] === 'image' && !marks"
           class="navigation-function">
        <ul class="navigation-function-list">
          <li class="navigation-function-button"
              @click="onSegmentRequest"><img class="icon-size"
                 src="../icon/segment.png" />
            <p> {{ segmentedIndex >= 0
              ? '还原'
              : '智能抠图'
            }}</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('maximize')"><fullscreen-outlined class="icon-size" />
            <p>最大化</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('spreadOut')"><arrows-alt-outlined class="icon-size" />
            <p>平铺</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('heightMaximization')"><column-height-outlined class="icon-size" />
            <p>最大高</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('widthMaximization')"><column-width-outlined class="icon-size" />
            <p>最大宽</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('flipHorizontal')">
            <img style="width: 13px;height: 20px;"
                 src="/images/flipHorizontal.png" />
            <p>水平翻转</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditing('flipVertical')">
            <div style="height:20px;">
              <img style="width: 20px;height: 13px;"
                   src="/images/flipVertical.png" />
            </div>
            <p>垂直翻转</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingrRotate(true)"><rotate-left-outlined class="icon-size" />
            <p>逆时针45°</p>
          </li>
          <li class="navigation-function-button"
              @click="onEditingrRotate(false)"><rotate-right-outlined class="icon-size" />
            <p>顺时针45°</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="navigation"
         :style="textInputFocus ? '' : ''">
      <!-- 导航栏 -->
      <ul class="node-list node-space-around">
        <li class="node-content"
            @click="materialLibrary">
          <p :style="currentNavigationNode === 0 ? 'color:white;' : ''">素材库</p>
          <div v-show="currentNavigationNode === 0"
               class="current-selected" />
        </li>
        <li class="node-content"
            @click="onSelectScale">
          <p :style="currentNavigationNode === 1 ? 'color:white;' : ''">尺寸</p>
          <div v-show="currentNavigationNode === 1"
               class="current-selected" />
        </li>
        <li class="node-content"
            @click="addCustomText">
          <p :style="currentNavigationNode === 2 ? 'color:white;' : ''">文字</p>
          <div v-show="currentNavigationNode === 2"
               class="current-selected" />
        </li>
        <li class="node-content">
          <a-upload id="upload"
                    :show-upload-list="false"
                    :action="toUrl('/v1/api/directAttachment/material')"
                    :with-credentials="true"
                    :file-list="fileList"
                    accept="image/*"
                    :before-upload="verifyUploadImgName"
                    @change="handleChange">
            <p :style="currentNavigationNode === 3 ? 'color:white;' : ''"
               @click.stop="byToken">图片</p>
            <div v-show="currentNavigationNode === 3"
                 class="current-selected" />
          </a-upload>
          <!-- <p @click="onChooseImage">图片</p> -->
        </li>
      </ul>
    </div>
    <!-- 素材库 -->
    <a-drawer :visible="materialVisible"
              :closable="false"
              class="fb-css-ignore-custom-mini"
              placement="bottom"
              @close="materialVisible = false">
      <ul class="material-category material-border">
        <li v-for="(item, index) in tagList"
            :key="index"
            class="material-category-li"
            @click="onSelectedMaterialTag(item.key)">
          <p :class="currentMaterialTag.indexOf(item.key) === -1 ? '' : 'current-category-text'">{{ item.name }}</p>
          <div v-show="currentMaterialTag.indexOf(item.key) != -1"
               class="current-category"></div>
        </li>
      </ul>
      <!-- <ul class="material-category">
        <li v-for=" (item, index)  in  materialImages[currentMaterialCategory].materialCategory "
            :class="['material-category-style-li', currentMaterialImages === index ? 'material-category-style-black' : '']"
            @click="onSelectedMaterialImage(index)">
          <p> {{ item.name }}</p>
        </li>
      </ul> -->
      <ul class="material-category-images">
        <li v-for="item in materialList"
            class="material-category-iamges-li"
            @click="addImage(item.image)">
          <img class="material-category-image"
               :src=toUrl(item.image) />
        </li>
      </ul>
    </a-drawer>
  </div>
</template>
<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import { toUrl, verifyUploadImgName } from "@/utils"
import { computed, onMounted, ref, watch } from 'vue'
import { ImageCustomizeEditor } from '@iota-cn/ui-components'
// import ThreeDimensional from '../view/ThreeDimensional.vue'
// import ImageCustomizeEditor from './ImageCustomizeEditor.vue'
import type { UploadProps } from 'ant-design-vue'
import type { UploadChangeParam } from 'ant-design-vue/es/upload/interface'
import { useRoute, type LocationQueryValue } from 'vue-router'
import { getCustomSpu, getMaterialList, signinByToken, submitCustomSpu, uploadCustomImage, fetchMaterialTag, addMateriaImage } from '../api/index'
import { EditingImage, type MaterialItem, type CustomizedAreasScale, type selectType, type Color, type MaterialTag, type CustomAreaImgHistory, type CustomizedImage, type NewCustomSpu, type Spu, type ThreeDimensionalModelInfo } from '../types'
import { findCustomableImage, templateBasicParameters, convertImageAndColor, requestSegmentHDCommonImage } from "../utils"
import wx from 'weixin-js-sdk'
import { selectedSpuData } from "../../index"

const segmentImg = ref<string>('')
const segmentedLoading = ref<boolean>(false)
const currentMaterialTag = ref<string[]>([])
const customizedAreasScale = ref<CustomizedAreasScale[]>([])
const currentCustomizedAreaScaleIndex = ref<number>(0)
const marks = ref<Record<number, any> | undefined>()
const currentNavigationNode = ref<number | null>(null)
const baseFontFamily = ref<selectType>()
const systemIsIos = ref<boolean>()
const androidFontFamilyData = ref<Array<selectType>>([
  {
    value: 'Source Han Serif SC',
    label: '思源宋体'
  },
  {
    value: 'FZLanTingHeiS-L-GB-Regular',
    label: '方正兰亭黑'
  },
  {
    value: 'STZhongsong',
    label: '华文中宋'
  }
])

const customScale = ref<number>(3)

const assignCustomizedData = computed(() => (item: any) => {
  return Object.assign({}, item.image.custom_areas, { scale: customScale.value })
})

const iosFontFamilyData = ref<Array<selectType>>([
  {
    value: 'PingFangSC-Regular, sans-serif',
    label: '苹方-常规'
  },
  {
    value: 'PingFangSC-Ultralight, sans-serif',
    label: '苹方-极细'
  },
  {
    value: 'PingFangSC-Light, sans-serif',
    label: '苹方-细'
  },
  {
    value: 'PingFangSC-Thin, sans-serif',
    label: '苹方-纤细'
  },
  {
    value: 'PingFangSC-Medium, sans-serif',
    label: '苹方-中黑'
  },
  {
    value: 'PingFangSC-Semibold, sans-serif',
    label: '苹方-中粗'
  },
  {
    value: 'San Francisco',
    label: 'San Francisco'
  }, {
    value: 'Marker Felt',
    label: 'Marker Felt'
  }, {
    value: 'Noteworthy',
    label: 'Noteworthy'
  },
  {
    value: 'Helvetica Neue',
    label: 'Helvetica Neue'
  },
  {
    value: 'Avenir Next',
    label: 'Avenir Next'
  }
])

const customAreaImgHistory = ref<CustomAreaImgHistory[]>([])
const materialList = ref<MaterialItem[]>([])
const tagList = ref<MaterialTag[]>([])
const customAreaITextcustomAreaAdjustment = ref<'text' | 'font' | 'stroke'>('text')
const customAreaIText = ref<string>('')
const materialVisible = ref<boolean>(false)
const currentNode = ref<number>(0)
const fileList = ref<UploadProps['fileList']>([])
const canvasActiveObject = ref<any>()
const route = useRoute()
const threeDimensionalModelsInfo = ref<Array<ThreeDimensionalModelInfo>>([])
const productDetailVisible = ref<boolean>(false)
const spuModel = ref<Spu>()
const currentSpu = ref<Spu>()
const customImgLoading = ref<boolean>(false)
const savingLoading = ref<boolean>(false)
const editingImages = ref<EditingImage[]>([])
const customAreaAdjustment = selectedSpuData().customAreaAdjustment
/**
 *组件变量
 */
const currentEditingImage = ref<EditingImage>()

// 图片切换
const onSelect = (image: EditingImage, index: number) => {
  currentNode.value = index
  currentEditingImage.value = image
  canvasActiveObject.value = currentEditingImage.value?.fabric.currentSelectionActiveObject()
  currentCustomizedAreaScaleIndex.value = image.image.scales.findIndex((r: any) => r.id === findCurrentCustomizedScale(image.image.id as number)!.id)
  if (canvasActiveObject.value)
    initCustomAdjustmentParams(canvasActiveObject.value)
  if (canvasActiveObject.value && canvasActiveObject.value.type === 'i-text')
    customAreaIText.value = canvasActiveObject.value.text
  const info = threeDimensionalModelsInfo.value
  info?.forEach((r: any) => {
    const relevanceNode = r.relevanceNodes.find((res: any) => res.customImageId == image.image.id)
    if (relevanceNode) {
      if (!r.relevanceSwatch.find((result: any) => result.currentLocation == relevanceNode.node)) {
        r.relevanceSwatch.push({
          currentLocation: relevanceNode.node,
          texture: '',
          customImageId: relevanceNode.customImageId
        })
      }
    }
  })
}

/**
 *颜色
 */
const currentAvailableColors = ref<Color[]>([])
const currentSelectedColors = ref<Color[]>([])
const selectedColors = ref<Color[]>([])
const currentColor = ref<Color>()
const editorContainer = ref()
const editorContainerDom = computed(() => {
  return editorContainer.value
})

watch(selectedColors, (newColors) => {
  currentColor.value = newColors[newColors.length - 1]
}, { deep: true })

watch(customAreaIText, (newV) => {
  currentEditingImage.value?.fabric.updateCurrentIText(newV)
})

watch(customAreaAdjustment, () => {
  if (currentEditingImage.value) {
    currentEditingImage.value.fabric.updateCustomArea(customAreaAdjustment)
  }
}, {
  deep: true
})

const segmentedIndex = computed(() => {
  if (canvasActiveObject.value && canvasActiveObject.value.type === 'image')
    return customAreaImgHistory.value.findIndex((r: CustomAreaImgHistory) => r.segmented === (segmentImg.value || (canvasActiveObject.value?.getSrc() || '')))
  else
    return customAreaImgHistory.value.findIndex((r: CustomAreaImgHistory) => r.segmented === (segmentImg.value || ''))
})

const isSHOss = () => {
  if (canvasActiveObject.value && canvasActiveObject.value.type === 'image')
    return canvasActiveObject.value.getSrc().match('-sh.oss-') || canvasActiveObject.value.getSrc().match('-shanghai.oss-')
}

const onSegmentRequest = () => {
  if (!canvasActiveObject.value || canvasActiveObject.value.type != 'image')
    return

  const urlMappings: Record<string, string> = {
    "https://test.flashbase.com/resources": "https://flashbase-test-sh.oss-cn-shanghai.aliyuncs.com",
    "https://www.flashbase.com/resources": "https://flashbase-product-sh.oss-cn-shanghai.aliyuncs.com",
    "https://flashbase.com/resources": "https://flashbase-product-sh.oss-cn-shanghai.aliyuncs.com"
  }

  const originalUrl: string = canvasActiveObject.value.getSrc()

  const updatedUrl = Object.entries(urlMappings).reduce((url, [key, value]) =>
    url.startsWith(key) ? url.replace(key, value) : url, originalUrl
  )

  segmentedLoading.value = true

  if (segmentedIndex.value >= 0) {
    currentEditingImage.value?.fabric.replaceImg(customAreaImgHistory.value[segmentedIndex.value].history)
    customAreaImgHistory.value.splice(segmentedIndex.value, 1)
    segmentedLoading.value = false
    return
  }

  // 凭证由后端 svc-pms 代理持有，前端不接触 AccessKey；内置 3 次重试 + 500ms 轮询 + 60s 超时保护
  requestSegmentHDCommonImage(updatedUrl, {
    onSuccess: (resultImageUrl) => {
      currentEditingImage.value?.fabric.replaceImg(resultImageUrl)
      customAreaImgHistory.value.push({
        history: canvasActiveObject.value.getSrc(),
        segmented: resultImageUrl
      })
      endPolling(undefined)
    },
    onProcessFailed: () => endPolling(undefined, '当前图片不支持抠图功能'),
    onTimeout: () => endPolling(undefined, 'cpu都烧干了，让我喘口气。'),
  })
}

const endPolling = (polling: any, mes?: string) => {
  if (mes)
    alert(mes)
  segmentedLoading.value = false
  clearInterval(polling)
}

const colorShow = computed(() => (item: Color) => {
  return currentSelectedColors.value.find(c => {
    return c.value === item.value
  })
})

const dragDrop = (operation: string, value: boolean) => {
  if (operation === 'scaling') {
    customAreaAdjustment.maximize = value
    customAreaAdjustment.spreadOut = value
    customAreaAdjustment.heightMaximization = value
    customAreaAdjustment.widthMaximization = value
  } else if (operation === 'flipHorizontal') {
    customAreaAdjustment.flipHorizontal = value
  } else {
    customAreaAdjustment.flipVertical = value
  }
}

const initCustomAdjustmentParams = (activeObject: any) => {
  if (activeObject.type === 'i-text') {
    baseFontFamily.value = activeObject.fontFamily
    customAreaAdjustment.fontFamily = activeObject.fontFamily
    customAreaAdjustment.linethrough = activeObject.linethrough
    customAreaAdjustment.underline = activeObject.underline
    customAreaAdjustment.textAlign = activeObject.textAlign
    customAreaAdjustment.fontBold = activeObject.fontWeight === 'bold'
    customAreaAdjustment.fontItalic = activeObject.fontStyle === 'italic'
    customAreaAdjustment.strokeWidth = activeObject.strokeWidth
    customAreaAdjustment.strokeColor = activeObject.stroke
    customAreaAdjustment.fontColor = activeObject.fill
    customAreaAdjustment.fontSize = activeObject.fontSize
  }
  customAreaAdjustment.flipHorizontal = activeObject.flipX
  customAreaAdjustment.flipVertical = activeObject.flipY
  customAreaAdjustment.rotate = activeObject.angle
}

const onSelectScale = () => {
  currentNavigationNode.value = 1
  if (currentEditingImage?.value && currentEditingImage.value.image.scales.length) {
    marks.value = {}
    currentEditingImage.value.image.scales.forEach((r: any, i: number) => {
      marks.value![i] = r.customized_areas_scale
    })
  }
}

const changeCustomizedScale = (value: number) => {
  const currentCustomized = customizedAreasScale.value.find((r: any) => r.customable_image_id === currentEditingImage.value?.image.id)
  const currentScale = currentEditingImage.value?.image.scales[value]
  currentCustomized!.customized_areas_scale = currentScale!.customized_areas_scale
  currentCustomized!.discount_amount_scale = currentScale!.discount_amount_scale
  currentCustomized!.title = currentScale!.title
  currentCustomized!.id = currentScale!.id
}

const onSelectedMaterialTag = (tag: string) => {
  const materialTagIndex = currentMaterialTag.value.indexOf(tag)
  if (materialTagIndex === -1)
    currentMaterialTag.value.push(tag)
  else
    currentMaterialTag.value.splice(materialTagIndex, 1)
  materialLibrary()
}

const onEditing = (adjustment: string) => {
  const tempArray = ['maximize', 'spreadOut', 'heightMaximization', 'widthMaximization']
  if (tempArray.indexOf(adjustment) >= 0) {
    customAreaAdjustment.rotate = 0
    setTimeout(() => {
      customAreaAdjustment[adjustment] = false
    }, 0)
  }
  customAreaAdjustment[adjustment] = !customAreaAdjustment[adjustment]
}

const onEditingrRotate = (anticlockwise: boolean) => {
  if (anticlockwise) {
    if (customAreaAdjustment.rotate < -135)
      customAreaAdjustment.rotate += 315
    else
      customAreaAdjustment.rotate -= 45
  } else {
    if (customAreaAdjustment.rotate > 135)
      customAreaAdjustment.rotate -= 315
    else
      customAreaAdjustment.rotate += 45
  }
}

const onEditingIText = (alignment: string) => {
  customAreaAdjustment.textAlign = alignment
}

const activeObject = (selected: any, segmentImgUrl?: string) => {
  currentNavigationNode.value = 2
  marks.value = undefined
  if (selected) {
    initCustomAdjustmentParams(selected)
    if (selected.type === 'i-text')
      customAreaIText.value = selected.text
  }
  if (segmentImgUrl)
    segmentImg.value = segmentImgUrl
  else
    segmentImg.value = ''
  canvasActiveObject.value = selected
}

const findCurrentCustomizedScale = (image_id: number) => {
  return customizedAreasScale.value.find((r: any) => r.customable_image_id === image_id)
}

const addImage = (imageUrl: string) => {
  customImgLoading.value = true
  materialVisible.value = false
  const imageTransformUrl = toUrl(imageUrl)
  currentEditingImage.value?.fabric.addImageToCustomArea(imageTransformUrl)
}

const mandatorySettingUpload = () => {
  const tempChangeInput = document.getElementById('upload')
  if (tempChangeInput) {
    tempChangeInput.setAttribute('accept', 'image/*')
    tempChangeInput.removeAttribute('capture')
  }
}

const handleChange = ({ file }: UploadChangeParam) => {
  customImgLoading.value = true
  fileList.value = []
  fileList.value.push(file)
  marks.value = undefined
  currentNavigationNode.value = 3
  mandatorySettingUpload()
  customImgLoading.value = true
  if (file.status === 'done') {
    const data = {
      image: '',
      name: '',
      specifications: ''
    }
    data.image = file.response.uploaded
    data.name = file.name
    const img = new Image()
    img.src = toUrl(file.response.uploaded) as string
    img.onload = async () => {
      const size = file.size ? (file.size / 1024).toFixed(2) : ''
      data.specifications = `尺寸：${img.width}x${img.height} 格式：${file.type} 大小：${size}KB`
      await addMateriaImage(data)
      currentEditingImage.value?.fabric.addImageToCustomArea(data.image)
      // await getMaterialList({}).then((result: any) => {
      //   // materialItems.value = result.rows

      // })
    }
  }
  // setTimeout(() => {
  //   update3d(currentEditingImage.value as EditingImage)
  // }, 300)
  if (file.status === 'error') {
    customImgLoading.value = false
    alert('图片上传失败，请确认格式')
    fileList.value = []
  }
}

const changeFontFamily = (value: string, option: any) => {
  baseFontFamily.value = option
  customAreaAdjustment.fontFamily = value
}

const onSelectColor = (color: Color) => {
  currentColor.value = color
  const keys = currentSelectedColors.value.indexOf(color)

  if (keys === -1) {
    selectedColors.value.push(color)
    currentSelectedColors.value.push(color)
  } else {
    const deleteKey = currentSelectedColors.value.indexOf(color)
    const currentKey = currentSelectedColors.value.indexOf(currentColor.value)
    if (currentSelectedColors.value.length > 1)
      currentSelectedColors.value.splice(deleteKey, 1)

    if (currentKey === deleteKey)
      currentColor.value = currentSelectedColors.value[0]
  }
}

const selectCurrentColor = (color: Color) => {
  currentColor.value = color
}

const addCustomText = () => {
  currentNavigationNode.value = 2
  currentEditingImage.value?.fabric.addTextToCustomArea('更改内容', true)
}
const withCookies = ref(false)
const token = ref<string | LocationQueryValue[]>('')
const disableIOSAmplification = () => {
  const viewportMetaTag = document.querySelector('meta[name="viewport"]')
  if (viewportMetaTag)
    viewportMetaTag.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=no')
}
const currentsystemIsIos = () => {
  const agent = navigator.userAgent.toLowerCase()
  const isIos = /iphone|ipad|ipodmac os x/i.test(navigator.userAgent)
  if (agent.indexOf("android") >= 0) {
    systemIsIos.value = false
  }
  if (isIos) {
    disableIOSAmplification()
    systemIsIos.value = true
  }

  baseFontFamily.value = systemIsIos.value ? iosFontFamilyData.value[0] : androidFontFamilyData.value[0]
  customAreaAdjustment.fontFamily = baseFontFamily.value.value
}

const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
const originalWidth = document.documentElement.clientWidth || document.body.clientWidth
const textInputFocus = ref<boolean>(false)
const onWindowResize = (type?: string) => {
  const htmlContent = document.getElementById('content')
  if (htmlContent) {
    htmlContent.style.height = originalHeight + 'px'
    htmlContent.style.width = originalWidth + 'px'
  }
}

const focusText = () => {
  textInputFocus.value = true
  onWindowResize()
}

const blurText = () => {
  textInputFocus.value = false
  onWindowResize()
}

// const wxConfig = async () => {
//   await fetchWXConfig({ url: window.location.href })
//     .then((res: any) => {
//       wx.config({
//         debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//         appId: res.appId, // 必填，微信公众号的唯一标识，此处填写公众号的appId
//         timestamp: res.timestamp, // 必填，生成签名的时间戳
//         nonceStr: res.nonceStr, // 必填，生成签名的随机串
//         signature: res.signature,// 必填，签名
//         jsApiList: ['chooseImage', 'updateAppMessageShareData', 'getLocalImgData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//       })
//     })
// }

// const onWxShare = () => {
//   wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
//     wx.updateAppMessageShareData({
//       title: '测试', // 分享标题
//       desc: '测试描述', // 分享描述
//       link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//       imgUrl: '/images/share.png', // 分享图标
//       success: function () {
//         // 设置成功
//         console.log('分享成功')

//       },
//       fail: (err) => {
//         alter('分享朋友设置失败==' + err)
//       }
//     })
//   })

//   // let infoList = {
//   //   type: "share",//H5消息的消息类型
//   //   messageData: {
//   //     shareTitle: "测试分享功能",//分享标题
//   //     shareImageUrl: "/images/share.png",//分享截图(小程序可以截当前分享页面图，当然也可以使用传过去的图)
//   //     sharePathUrl: "/pages/customized/index",//分享小程序页面(如需要参数则此地址需要拼接，注意这里的参数有长度限制)
//   //   }
//   // }
//   // wx.miniProgram.postMessage({ data: infoList });
//   // console.log('已经传递给小程序');

// }

// const onChooseImage = () => {
//   wx.ready(() => {
//     wx.chooseImage({
//       count: 1, // 默认9
//       sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
//       sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
//       success: function (res) {
//         let localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
//         wx.getLocalImgData({
//           localId: localIds[0], // 图片的localID
//           success: function (res) {
//             let localData = res.localData // localData是图片的base64数据，可以用img标签显示
//             marks.value = undefined
//             currentNavigationNode.value = 3
//             mandatorySettingUpload()
//             // const imgUrl = URL.createObjectURL(localData as Blob)
//             currentEditingImage.value?.fabric.addImageToCustomArea(localData)
//             setTimeout(() => {
//               update3d(currentEditingImage.value as EditingImage)
//             }, 300)
//           }
//         })
//       }
//     })
//   })
// }

onMounted(async () => {
  currentsystemIsIos()
  onWindowResize()
  mandatorySettingUpload()

  // wxConfig()
  const categoryId = route.query.categoryId as string || '' as string
  const spuId = route.query.spuId as string || ''
  const iota = route.query.iota || ''
  const iotaSig = route.query.iotaSig || ''
  token.value = route.query.id || ''

  if (iota != 'undefined' && iotaSig != 'undefined') {
    document.cookie = "fb-c@iota" + '=' + iota + ';path=/'
    document.cookie = "fb-c@iota.sig" + '=' + iotaSig + ';path=/'
    withCookies.value = true
  }

  if (categoryId && spuId)
    initDesignData(categoryId, spuId)
})

const isLogin = () => {
  const iota = route.query.iota || ''
  const iotaSig = route.query.iotaSig || ''
  if (iota === 'undefined' && iotaSig === 'undefined') {
    return false
  }
  return true
}

const byToken = (_: MouseEvent | null, submit?: any) => {
  if (!isLogin()) {
    signinByToken(token.value as string).then(async (res: any) => {
      withCookies.value = true
      if (submit)
        submit()
      else
        uploadImg()
    }).catch(() => {
      wx.miniProgram.navigateTo({
        url: `/package-advance/design/customized/components/webview`
      })
    })
  } else if (!submit) {
    uploadImg()
  }
}

const byNativeToken = (_: MouseEvent | null, submit?: any) => {
  if (!isLogin()) {
    signinByToken(token.value as string).then(async (res: any) => {
      withCookies.value = true
      if (submit)
        submit()
      else
        uploadImg()
    }).catch(() => {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'DESIGN_COMPLETE',
        code: 400,  // 或其他错误码
        data: {},
        message: 'no signin'
      }))
    })
  } else if (!submit) {
    uploadImg()
  }
}

const uploadImg = () => {
  const tempChangeInput = document.getElementById('upload')
  if (tempChangeInput) {
    tempChangeInput.click()
  }
}

const isOk = async () => {
  if (!editingImages.value.find((r: any) => r.fabric.isCustomized())) {
    alert('您还未对您的商品进行设计')
    return
  }

  savingLoading.value = true
  const customSpu: NewCustomSpu = { spu_id: 0, colors: [], name: '', customizedImages: [] }
  customSpu.spu_id = currentSpu.value?.id
  customSpu.colors = selectedColors.value
  customSpu.price = currentSpu.value?.price || 0
  customSpu.name = '小程序-' + currentSpu.value?.name
  // customSpu.name=

  const imgPromises: Array<Promise<string>>[] = []
  editingImages.value.forEach((element) => {
    if (element.fabric.isCustomized()) {
      const custom = {
        custom_area_id: element.image.custom_areas.id,
        spu_customable_image_id: element.image.id,
        customized_image: '',
        customized_json: {},
        customized_areas: { customable_image_scale: customScale.value || 2, customized_areas_scale: 1, discount_amount_scale: 1, boundingRect: {} },
      }
      const currentScale = findCurrentCustomizedScale(element.image.id)
      custom.customized_areas.customized_areas_scale = currentScale!.customized_areas_scale
      custom.customized_areas.discount_amount_scale = currentScale!.discount_amount_scale
      customSpu.customizedImages?.push(custom)
      imgPromises.push(element.fabric.exportVisualCustomAreaImageAsBlobAsync().then((
        { blob, boundingRect }: { blob: Blob, boundingRect: { left: number, top: number, width: number, height: number } }
      ) => {
        custom.customized_areas.boundingRect = boundingRect
        return uploadCustomImage(blob).then((image: string) => {
          custom.customized_image = image
          custom.customized_json = element.fabric.exportCustomAreaJson()
        }).catch((res: any) => {
        })
      }))
    }
  })

  Promise.all(imgPromises).then(async () => {
    savingLoading.value = false
    if (!withCookies.value) {
      // @ts-ignore
      if (window.ReactNativeWebView) {
        byNativeToken(null, async () => {
          const res: any = await submitCustomSpu(customSpu)
          // @ts-ignore
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'DESIGN_COMPLETE',
            code: 200,
            data: { id: res.id },
            message: 'saved design success'
          }))
        })

      } else {
        byToken(null, async () => {
          const res: any = await submitCustomSpu(customSpu)
          wx.miniProgram.redirectTo({
            url: `/pages/category/components/preview?spu_id=${res.id}`
          })
        })
      }
    } else {
      // @ts-ignore
      if (window.ReactNativeWebView) {
        const res: any = await submitCustomSpu(customSpu)
        // @ts-ignore
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'DESIGN_COMPLETE',
          code: 200,
          data: { id: res.id },
          message: 'saved design success'
        }))
      } else {
        const res: any = await submitCustomSpu(customSpu)
        wx.miniProgram.redirectTo({
          url: `/pages/category/components/preview?spu_id=${res.id}`
        })
      }
    }
  })
}

const materialLibrary = async () => {
  marks.value = undefined
  currentNavigationNode.value = 0
  if (!tagList.value.length)
    await fetchMaterialTag().then(result => {
      tagList.value = result.data.items
    })

  if (currentMaterialTag.value.length)
    await getMaterialList({ tag: currentMaterialTag.value.join(',') }).then((result: any) => {
      materialList.value = result
    })
  else
    await getMaterialList().then((result: any) => {
      materialList.value = result
    })
  materialVisible.value = true
  setTimeout(() => {
    const tempDom = document.getElementsByClassName('ant-drawer-content')[0] as any
    if (tempDom) {
      tempDom.style.borderTopLeftRadius = 20 + 'px'
      tempDom.style.borderTopRightRadius = 20 + 'px'
    }
  }, 0)
}

const initDesignData = async (categoryId: string, spuId: string) => {
  const res: any = await getCustomSpu(categoryId, spuId)
  const spu: Spu = res as Spu
  spu.attrs = spu.attrs || []
  currentAvailableColors.value = convertImageAndColor(res)
  currentSpu.value = spu
  if (currentAvailableColors.value.length > 0) {
    if (selectedColors.value.length < 1) {
      selectedColors.value.push(currentAvailableColors.value[0])
      currentSelectedColors.value.push(currentAvailableColors.value[0])
    }
    currentColor.value = currentAvailableColors.value[0]
  }
  editingImages.value = (spu?.customableImages || []).map((i) => {
    return new EditingImage(i as CustomizedImage)
  })
  currentEditingImage.value = editingImages.value[0]

  editingImages.value.forEach((r: any) => {
    const currentScale = r.image.scales.find((rr: any) => Number(rr.customized_areas_scale) === 1)
    const currentScaleIndex = r.image.scales.findIndex((rr: any) => Number(rr.customized_areas_scale) === 1)
    if (currentScale) {
      customizedAreasScale.value.push({
        customable_image_id: r.image.id,
        discount_amount_scale: currentScale.discount_amount_scale,
        customized_areas_scale: currentScale.customized_areas_scale,
        title: currentScale.title,
        id: currentScale.id
      })
      currentCustomizedAreaScaleIndex.value = currentScaleIndex
    } else {
      customizedAreasScale.value.push({
        customable_image_id: r.image.id,
        discount_amount_scale: r.image.scales[0].discount_amount_scale,
        customized_areas_scale: r.image.scales[0].customized_areas_scale,
        title: r.image.scales[0].title,
        id: r.image.scales[0].id
      })
      currentCustomizedAreaScaleIndex.value = 0
    }

    if (currentAvailableColors.value.length > 0) {
      if (selectedColors.value.length < 1) {
        selectedColors.value.push(currentAvailableColors.value[0])
      }
      currentColor.value = currentAvailableColors.value[0]
    }
  })

  getModelInfo(res)

  if (currentSpu.value) {
    productDetailVisibleFunc(true)
  }
}

const imgLoading = (loading: boolean) => {
  customImgLoading.value = loading
}

const getModelInfo = (spuValue: any) => {
  threeDimensionalModelsInfo.value = []
  setTimeout(() => {
    spuModel.value = spuValue
    spuValue?.threeDimensional.forEach((item: any) => {
      const swatch = item.corresponding.find((r: any) => r.customImageId == currentEditingImage.value?.image.id)
      const prestore = {
        relevanceNodes: item.corresponding,
        relevanceSwatch: [{
          currentLocation: swatch.node,
          texture: '',
          customImageId: swatch.customImageId
        }],
        url: toUrl(item.model)!,
        preview: item.preview
      }
      if (item.preview) {
        threeDimensionalModelsInfo.value.unshift(prestore)
      } else {
        threeDimensionalModelsInfo.value.push(prestore)
      }
    })
  }, 0)
}

// const update3d = (element: EditingImage) => {
// marks.value = undefined
// const info = threeDimensionalModelsInfo.value
// element.fabric.exportCustomAreaImageAsImageDataAsync().then((
//   img: ImageData
// ) => {
//   info.forEach((r: any) => {
//     r.value
//   })
//   threeDimensionalModelsInfo.value.forEach((r: any) => {
//     const temp = r.relevanceSwatch.find((res: any) => res.customImageId == currentEditingImage.value?.image.id)
//     if (temp)
//       temp.texture = img
//   })
// }).catch((err: any) => {
//   console.log(err)
// })
// }

const isCustomized = ref<boolean>(false)

const onCustomized = (value: boolean) => {
  if (value) {
    isCustomized.value = true
  }
  else {
    isCustomized.value = !!editingImages.value.find((e) => {
      return e.fabric.isCustomized()
    })
  }
  canvasActiveObject.value = undefined
}
const productDetailVisibleFunc = (switchField: boolean) => {
  productDetailVisible.value = switchField
}

</script>

<style lang="less">
.fb-css-ignore-custom-mini {
  .ant-select-item {
    min-height: 12px;
    padding: 4px;
    font-size: 12px;
    line-height: 12px;
  }


  .ant-drawer-body {
    font-size: 12px;
    padding-top: 0;
  }
}
</style>

<style scoped lang="less">
div::-webkit-scrollbar {
  display: none;
}

@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('https://www.flashbase.com/weapp/fonts/SourceHanSansCN-Regular.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SourceHanSansCN-Medium';
  src: url('https://www.flashbase.com/weapp/fonts/SourceHanSansCN-Medium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'SourceHanSansCN-Bold';
  src: url('https://www.flashbase.com/weapp/fonts/SourceHanSansCN-Bold.woff2') format('woff2');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

.material-category {
  position: sticky;
  font-family: SourceHanSansCN-Regular;
  height: 10%;
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  padding: 0 2px;
  top: 0;
  background-color: white;

  .material-category-li {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 5px;
    margin: 0 5px;

    p {
      font-size: 14px;
      margin: 0;
      color: #a9a9a9;
      margin-bottom: 5px;
    }

    .current-category {
      border-radius: 50px;
      width: 25px;
      height: 4px;
      background-color: black;
    }

    .current-category-text {
      font-family: 'SourceHanSansCN-Bold';
      color: black;
    }
  }

  .material-category-style-li {
    min-width: 17%;
    height: 85%;
    text-align: center;
    margin: 0 5px;
    border: 2px solid #999999;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    p {
      // height: 20%;
      font-size: 12px;
      margin: 0;
    }
  }

  .material-category-style-black {
    background-color: black;
    color: white;
  }

  .material-node {
    min-width: 15%;
    height: 80%;
    font-size: 14px;
    text-align: center;
    line-height: 190%;
    margin: 0 5px;
  }

  .material-images {
    min-width: 20%;
    height: 20%;
    text-align: center;
    line-height: 200%;
  }
}

.material-category-images {
  padding-left: 2px;
  font-family: SourceHanSansCN-Regular;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;

  .material-category-iamges-li {
    flex: 1;

    .material-category-image {
      max-width: 100%;
      flex: 1;
      border-radius: 10px;
      background-color: #dedbdb;
    }
  }
}

.material-border {
  border-bottom: 1px solid rgb(231, 231, 231);
}

.material-category::-webkit-scrollbar {
  display: none;
}

:deep(.ant-drawer)::-webkit-scrollbar {
  display: none;
}

.custom-spu-designer-content-mini {
  font-size: 12px;
  width: 100vw;
  height: 100vh;
  font-family: 'SourceHanSansCN-Regular';
  position: relative;
  touch-action: none;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;

  .color-name {
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    color: #999999;
  }

  :deep(.ant-select) {
    font-size: 12px;
  }

  :deep(.ant-input) {
    font-size: 12px;
  }

  :deep(.ant-input-number-input) {
    font-size: 12px;
  }

  :deep(.ant-slider-rail) {
    height: 3px !important;
    background-color: #f5f5f574 !important;
  }

  :deep(.ant-slider-track) {
    height: 3px !important;
    background-color: #f5f5f5 !important;
  }

  :deep(.ant-slider-handle) {
    border: 0px solid;
    width: 15px;
    height: 15px;
    margin-top: -5px;
  }

  :deep(.ant-slider-dot) {
    top: -1px;
    width: 5px;
    height: 5px;
    margin: 0;
    border: 1px solid #f0f0f0;
  }

  :deep(.ant-input-number-input) {
    height: 100%;
  }

  .current-node {
    color: white;
    background: black;
  }

  .materialImages {
    padding-top: 5px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .materialImage {
      width: 20%;
      height: 20%;
      box-shadow: 0px 0px 10px rgb(171, 170, 170);
    }
  }

  :deep(.ant-select) {
    color: white;

    // background-color: #11111100 !important;
    .ant-select-selector {
      border: 1px solid grey;
      background-color: #11111100 !important;
    }

    .ant-select-arrow {
      color: #FFFFFF;
    }
  }

  :deep(.ant-select-dropdown) {
    font-size: 16px;
  }

  :deep(.ant-select-arrow) {
    right: 10px;
    top: 25%;
    width: 8px;
    height: 5px;
    font-size: 14px;
    // margin-top: -20px;
  }

  :deep(.ant-select-single:not(.ant-select-customize-input) .ant-select-selector) {
    height: 20px;
  }

  :deep(.ant-select-single .ant-select-selector .ant-select-selection-item) {
    line-height: 20px;
  }

  .color-selected-title {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 0 16px;
  }

  .color-list {
    z-index: 999;
    width: 100vw;
    display: flex;

    .color-list-area {
      margin-left: 16px;
      margin-top: 5vw;
      // height: 40vw;
      display: flex;
      align-items: center;
      // justify-content: space-around;
      overflow: auto;
      gap: 10px;

      .color-seleted {
        display: flex;
        flex-flow: column;
        align-items: center;

        .color-seleted-icon {
          width: 7px;
          height: 6px;
        }
      }

      .color-outer-layer {
        border-radius: 5px !important;
        margin-bottom: 5px;
        border: 1px solid rgb(215, 215, 215);
        align-items: center;
        display: flex;
        justify-content: space-around;
      }

      .color-item {
        border-radius: 5px;
        min-height: 7.5vw !important;
        max-height: 7.5vw !important;
        max-width: 7.5vw !important;
        min-width: 7.5vw !important;
        color: #a2a2a2;
        background-size: 100%;
        align-items: center;
        display: flex;
        justify-content: space-around;
      }

      .selected-color {
        border: 1px solid black;
      }
    }
  }

  .operation {
    display: flex;
    margin: 16px;
    justify-content: space-between;

    .customable-group {
      font-family: SourceHanSansCN-Regular;
      border-radius: 5px;
      background: #F6F6F6;
      border: 2px solid #E6E6E6;
      min-height: 32px;
      z-index: 99;
      color: #999999;
      display: flex;

      .customable-switch {
        height: 32px;
        width: 32px;
        border-radius: 5px;
        font-size: 14px;
        text-align: center;
        line-height: 32px;
        display: flex;
        justify-content: space-around;
      }
    }

    .complete {
      width: 80px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: #F6F6F6;
      border: 2px solid #E6E6E6;
      border-radius: 5px;

      span {
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
      }
    }
  }

  .image-customize-editor {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    overflow: hidden;
    padding: 30px;

    :deep(.ant-spin-nested-loading > div > .ant-spin) {
      top: 50%;
      max-height: 0;
    }

    :deep(.ant-spin-dot-item) {
      width: 30px;
      height: 30px;
    }

    :deep(.ant-spin-text) {
      margin-top: 50px;
      font-family: SourceHanSansCN-Regular;
      font-size: 14px;
    }

    .hidden {
      display: none;
    }
  }

  .navigation {
    height: 76px;
  }

  .navigation-extend,
  .navigation {
    box-shadow: 0px 5px 10px rgb(59, 59, 59);
    width: 100%;

    .navigation-title-extended {
      width: 100%;
      height: 50px;
      background: #111111bb;
      bottom: 180%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      bottom: 200%;

      .navigation-title-extended-edit {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .navigation-title-extended-edit-slider {
          margin-left: 2%;
          width: 54.5%;
          display: flex;
          align-items: center;
          justify-content: center;

          .edit-slider {
            width: 75%;


          }
        }

        .navigation-title-extended-edit-input {
          margin-left: 5px;
          width: 23%;
          background: #111111bb;
          color: white;
          border: 1px solid grey
        }

        .navigation-title-extended-edit-select {
          height: 20%;
          width: 26%;
        }

        .navigation-title-extended-edit-color {
          float: right;
          width: 10%;

        }
      }
    }

    .icon-size {
      width: 20px;
      height: 20px;
      font-size: 20px;
    }

    .node-list {
      background-color: #111111;
      border-top: 1px solid #3d3d3d;
      height: 100%;
      width: 100%;
      display: flex;

      .node-content {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 10px;

        p {
          font-family: 'SourceHanSansCN-Medium';
          color: #999999;
          font-size: 14px;
          margin: 0;
          margin-bottom: 7px;
        }

        .current-selected {
          border-radius: 10px;
          width: 25px;
          height: 2px;
          background-color: white;
        }
      }
    }

    .navigation-scale {
      width: 100%;
      height: 50px;
      background: #111111bb;
      display: flex;
      justify-content: center;
      align-items: center;

      .navigation-scale-title {
        color: white;
        width: 15%;
        margin-right: 20px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .navigation-scale-slider {
        width: 70%;
      }
    }

    .navigation-function {
      width: 100%;
      background: #111111;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .navigation-function-list {
        height: 100%;
        color: white;
        justify-content: space-between;
        width: 100%;
        display: flex;
        overflow-x: auto;
        white-space: nowrap;

        .navigation-function-button {
          margin: 0 2px;
          padding-top: 8%;
          min-width: 20%;
          display: flex;
          width: 20%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }

      .navigation-function-list::-webkit-scrollbar {
        display: none;
      }
    }

    .node-space-around {
      justify-content: space-around;
    }

    .node-space-between {
      justify-content: space-between;
    }

    .node-content-width {
      min-width: 20%;
    }
  }
}
</style>
